import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/cenik-icons/plain-tooth.png'
import _imports_1 from '@/assets/svg/xray.svg'
import _imports_2 from '@/assets/svg/brush.svg'
import _imports_3 from '@/assets/cenik-icons/decay.png'
import _imports_4 from '@/assets/cenik-icons/sparkling.png'
import _imports_5 from '@/assets/cenik-icons/endo.png'
import _imports_6 from '@/assets/png-icons/laser.png'
import _imports_7 from '@/assets/cenik-icons/bridge.png'
import _imports_8 from '@/assets/cenik-icons/prosthesis.png'
import _imports_9 from '@/assets/svg/pliers.svg'
import _imports_10 from '@/assets/svg/braces2.svg'
import _imports_11 from '@/assets/cenik-icons/parodontosis.png'
import _imports_12 from '@/assets/svg/products.svg'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "!mb-8" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "disclaimer" }
const _hoisted_10 = { class: "mt-rem3" }

import { ref, watch, Ref, toRefs } from 'vue'
import SocutnoLogo from '@/components/SocutnoLogo.vue'
import CenikTitle from '@/components/CenikTitle.vue'
import CenikItem from '@/components/CenikItem.vue'
import CenikDivider from '@/components/CenikDivider.vue'
import Footer from '@/components/Footer.vue'
import { htmlElementsUntil } from '@/utils/utils'
import CloseButton from '@/components/CloseButton.vue'
import LanguageButtonStandalonePage from '@/blocks/languageButtonStandalonePage.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Cenik',
  props: {
    marked: {}
  },
  emits: ["close", "navigate"],
  setup(__props: any) {

const props = __props



const { marked } = toRefs(props)

const content: Ref<HTMLElement | null> = ref(null)
const grid: Ref<HTMLElement | null> = ref(null)

watch(
    [marked, content, grid],
    () => {
        if (!content.value || !grid.value) return

        clearMarkedRows(grid.value)

        if (!marked.value) return

        const titleEl = content.value.querySelector(`#${marked.value}`)
        if (!titleEl) return

        const markedRows = [titleEl, ...htmlElementsUntil(['.divider'], titleEl)]
        markedRows.forEach(el => el.classList.add('marked'))
    },
    { immediate: true },
)

function clearMarkedRows(grid: HTMLElement) {
    const allRows = grid.querySelectorAll('.marked')
    allRows.forEach(el => el.classList.remove('marked'))
}

return (_ctx: any,_cache: any) => {
  const _component_icon_back = _resolveComponent("icon-back")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LanguageButtonStandalonePage, { "sticky-height": 250 }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "content",
        ref_key: "content",
        ref: content
      }, [
        _createVNode(CloseButton, {
          class: "close-button absolute top-1 right-0 text-pink-200",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }),
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('articles.cenik.title')), 1),
        _createVNode(SocutnoLogo, {
          small: "",
          class: "logo"
        }),
        _createElementVNode("div", {
          class: "grid mt-4",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "splosno" }, {
            default: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosno')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 40,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoPregled')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 50,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoPregledOtroci')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.sploslnoPosvet')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.splosnoPosvetnMin')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.sploslnoPredpisovanje')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoNapotnica')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoOtrokNePusti')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.splosnoOtrokNePustiMin')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoManjsiPoseg')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.splosnoManjsiPosegMin')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoSrednji')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 80 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.splosnoZahteven')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "rentgen" }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_1,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.rentgen')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 25,
            theme: "gray"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.rentgenOrtopan')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, null, {
            default: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("img", {
                src: _imports_2,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventiva')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 80,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaSonicno')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaPeskanje')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.preventivaPeskanjeNaC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaScetkaPoliranje')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.preventivaScetkaPoliranjeNaC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 20 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaFluoridi')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 20,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaFisure')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.preventivaFisureNaZ')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaPouk')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: [60, 80] }, {
            default: _withCtx(() => [
              _cache[16] || (_cache[16] = _createElementVNode("b", null, "SDF", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.preventivaSDF')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.preventivaSdfNaZ')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 25 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.preventivaGluma')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.preventivaGlumaNaK')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "zobne-bolezni" }, {
            default: _withCtx(() => [
              _cache[17] || (_cache[17] = _createElementVNode("img", {
                src: _imports_3,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezni')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 80 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezniMajhnaZ')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 90,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezniSrednjaZ')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 100 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezniVelikaZ')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: [50, 60],
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezniMlecniZ')) + " ", 1),
              _cache[18] || (_cache[18] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.zobneBolezniMlecniZTip')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikDivider),
          _createVNode(CenikItem, { price: 100 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezniDograditev')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            id: "injekcijska-tehnika",
            price: 180,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'injekcijska-tehnika')))
              }, _toDisplayString(_ctx.$t('articles.cenik.zobneBolezniInjekcijska')), 1),
              _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.zobneBolezniInjekcijskaOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikDivider),
          _createVNode(CenikItem, { price: 180 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.zobneBolezniBruksizem')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "estetika" }, {
            default: _withCtx(() => [
              _cache[20] || (_cache[20] = _createElementVNode("img", {
                src: _imports_4,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.estetika')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 140 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.estetikaDomace')) + " ", 1),
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate', 'beljenje')))
              }, "Opalescence GO")
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 220 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.estetikaDomaceIndividualno')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 350,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.estetikaDomaceLasersko')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 70 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.estetikaNots')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikDivider),
          _createVNode(CenikItem, { price: [140, 160, 180] }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.estetikaIcon')) + " ", 1),
              _cache[21] || (_cache[21] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.estetikaIconOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikDivider),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.esteitikaBisercek')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "endodontija" }, {
            default: _withCtx(() => [
              _cache[22] || (_cache[22] = _createElementVNode("img", {
                src: _imports_5,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontija')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 50,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaPolnitev')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 80 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaPolnitevEnok')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaOdstranjevanje')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.endodontijaOdstranjevanjeNaK')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaMenjava')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.endodontijaMenjavaPerK')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 10 }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('articles.cenik.endodontijaStrojno')
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 20 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaKritje')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.endodontijaKritjeDod')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 15 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaZacasna')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 50,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaTrepanacija')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 40 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaToksavit')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 20 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.endodontijaKritje')) + " (" + _toDisplayString(_ctx.$t('articles.cenik.endodontijaKritjeDod')) + ")", 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "lasersko" }, {
            default: _withCtx(() => [
              _cache[23] || (_cache[23] = _createElementVNode("img", {
                src: _imports_6,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.lasersko')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 150,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.laserskoParodontalno')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.laserskoParodontalnoPolUst')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 120,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.laserskoFrenulotomija')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.laserskoFrenulotomijaOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.laserskoFrenulotomijaSamo')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.laserskoFrenulotomijaSamoOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.laserskoManjsi')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 350 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.laserskoBeljenje')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "fiksna-protetika" }, {
            default: _withCtx(() => [
              _cache[24] || (_cache[24] = _createElementVNode("img", {
                src: _imports_7,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetika')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 350 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaKovinskoKer')) + " ", 1),
              _cache[25] || (_cache[25] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaKovinskoKerNaE')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 400,
            standout: "true"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaPolnoPor')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaPolnoPorNaE')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 300 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaInlay')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 350 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaInlayKer')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 400,
            standout: "true"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaLuska')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 120 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaFRC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 30 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaZacasna')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.fiksnaProtetikaZacasnaNaZ')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, null, {
            default: _withCtx(() => [
              _cache[26] || (_cache[26] = _createElementVNode("img", {
                src: _imports_8,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.snemnaProtetika')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 800,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.snemnaProtetikaTotalna')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 200 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.snemnaProtetikaDelnaZac')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 1000 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.snemnaProtetikaDelnaVizil')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 150 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.snemnaProtetikaPodlozitev')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 200 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.snemnaProtetikaFolija')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, null, {
            default: _withCtx(() => [
              _cache[27] || (_cache[27] = _createElementVNode("img", {
                src: _imports_9,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.kirurgija')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: [70, 90],
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.kirurgijaEkstrakcija')) + " ", 1),
              _cache[28] || (_cache[28] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.kirurgijaEkstrakcijaTip')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 100 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.kirurgijaKomplicirana')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 15,
            standout: "true"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.kirurgijaAnestezija')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: [40, 60] }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.kirurgijaMlecni')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.kirurgijaMlecniTip')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: [20, 50],
            "price-range": true,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.kirurgijaLaser')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "ortodontija" }, {
            default: _withCtx(() => [
              _cache[29] || (_cache[29] = _createElementVNode("img", {
                src: _imports_10,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.ortodontija')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 330,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('navigate', 'myobrace')))
              }, "Myobrace"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaMyobrace')) + " ", 1),
              _cache[30] || (_cache[30] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaMyobracePlus')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 100 }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('navigate', 'myobrace')))
              }, "Myobrace"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaMyobrace3')), 1),
              _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1))
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 100 }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('navigate', 'myobrace')))
              }, "Myobrace"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaMyobraceIzg')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaMyobraceIzgOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.ortodontijaLipTrainer')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 150 }, {
            default: _withCtx(() => [
              _cache[32] || (_cache[32] = _createElementVNode("b", null, "Froggy mouth", -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaFroggy')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikDivider),
          _createVNode(CenikItem, {
            id: "invisalign",
            price: 2600,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('navigate', 'invisalign')))
              }, "Invisalign"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignFirst')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: [1100, 1300] }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('navigate', 'invisalign')))
              }, "Invisalign"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignExpress')) + " ", 1),
              _cache[33] || (_cache[33] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignExpressNaC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: [2500, 2800] }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('navigate', 'invisalign')))
              }, "Invisalign"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignLite')) + " ", 1),
              _cache[34] || (_cache[34] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignLiteNaC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: [3000, 3200],
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('navigate', 'invisalign')))
              }, "Invisalign"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignModerate')) + " ", 1),
              _cache[35] || (_cache[35] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignModerateNaC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: [4300, 4800] }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('navigate', 'invisalign')))
              }, "Invisalign"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignComprehensive')) + " ", 1),
              _cache[36] || (_cache[36] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignComprehensiveNaC')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 450 }, {
            default: _withCtx(() => [
              _createElementVNode("b", {
                class: "internal-link",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('navigate', 'invisalign')))
              }, "Invisalign"),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.ortodontijaInvisalignVivera')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, { id: "parodontologija" }, {
            default: _withCtx(() => [
              _cache[37] || (_cache[37] = _createElementVNode("img", {
                src: _imports_11,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.parodontologija')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 120 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.parodontologijaOpornica')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 100,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.parodontologijaZdravljenje')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 50 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.parodontologijaLaser')) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.parodontologijaLaserDod')), 1)
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "grid",
          ref_key: "grid",
          ref: grid
        }, [
          _createVNode(CenikTitle, null, {
            default: _withCtx(() => [
              _cache[38] || (_cache[38] = _createElementVNode("img", {
                src: _imports_12,
                alt: "",
                class: "icon"
              }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.izdelki')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 7,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('articles.cenik.izdelkiScetka')) + " ", 1),
              _cache[39] || (_cache[39] = _createElementVNode("b", null, "Curaprox", -1)),
              _cache[40] || (_cache[40] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.izdelkiScetkaOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 16 }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('articles.cenik.izdelkiScetka3pack')
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 10,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('articles.cenik.izdelkiPasta')
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 7 }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('articles.cenik.izdelkiPastaKids')
              }, null, 8, _hoisted_6),
              _cache[41] || (_cache[41] = _createElementVNode("br", { class: "mobile-only" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('articles.cenik.izdelkiPastaKidsOpis')), 1)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 10,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('articles.cenik.izdelkiUstnaVoda')
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, { price: 15 }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('articles.cenik.izdelkiFluorprotector')
              }, null, 8, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(CenikItem, {
            price: 25,
            "stand-out": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.cenik.izdelkiMI')), 1)
            ]),
            _: 1
          })
        ], 512)
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_a_button, {
        class: "mt-rem3 mx-auto",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_icon_back, { size: 20 }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.cenik.back')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('articles.cenik.validFrom')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.cenik.vatNote')), 1)
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})